import { render, staticRenderFns } from "./GeneralTimeStreamax.vue?vue&type=template&id=4431b1dd&scoped=true&"
import script from "./GeneralTimeStreamax.vue?vue&type=script&lang=ts&"
export * from "./GeneralTimeStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralTimeStreamax.vue?vue&type=style&index=0&id=4431b1dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431b1dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4431b1dd', component.options)
    } else {
      api.reload('4431b1dd', component.options)
    }
    module.hot.accept("./GeneralTimeStreamax.vue?vue&type=template&id=4431b1dd&scoped=true&", function () {
      api.rerender('4431b1dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/TimeSetup/GeneralTimeStreamax.vue"
export default component.exports